import { isSupportedCurrency } from './currency.js';
import { deserializeMoney } from './money.js';
import { isOk } from '../contracts/result.js';
export function isPaymentLinkStatus(value) {
    return value === 'draft' || value === 'inactive';
}
export function isPaymentLinkVisibility(value) {
    return value === 'private' || value === 'public';
}
function isNullableString(value) {
    return value === null || typeof value === 'string';
}
export function isValidIsoDateString(value) {
    if (typeof value !== 'string' || value.trim().length === 0)
        return false;
    const timestamp = Date.parse(value);
    return !Number.isNaN(timestamp);
}
export function isPaymentLinkExpired(link, nowMs = Date.now()) {
    if (!link || !link.expiresAt)
        return false;
    const expiresMs = Date.parse(link.expiresAt);
    if (Number.isNaN(expiresMs))
        return false;
    return expiresMs <= nowMs;
}
export function isPaymentLink(value) {
    if (typeof value !== 'object' || value === null || Array.isArray(value))
        return false;
    const candidate = value;
    if (typeof candidate.id !== 'string' ||
        candidate.id.length === 0 ||
        typeof candidate.ownerUid !== 'string' ||
        candidate.ownerUid.length === 0 ||
        typeof candidate.slug !== 'string' ||
        candidate.slug.length === 0 ||
        typeof candidate.title !== 'string' ||
        candidate.title.length === 0 ||
        !isNullableString(candidate.description) ||
        !isPaymentLinkStatus(candidate.status) ||
        (candidate.visibility !== undefined && !isPaymentLinkVisibility(candidate.visibility)) ||
        (candidate.expiresAt !== undefined &&
            candidate.expiresAt !== null &&
            !isValidIsoDateString(candidate.expiresAt)) ||
        typeof candidate.createdAt !== 'string' ||
        typeof candidate.updatedAt !== 'string') {
        return false;
    }
    return isOk(deserializeMoney(candidate.amount));
}
export function isCreatePaymentLinkDraftInput(value) {
    if (typeof value !== 'object' || value === null || Array.isArray(value))
        return false;
    const candidate = value;
    const hasValidExpiresAt = candidate.expiresAt === undefined ||
        candidate.expiresAt === null ||
        (isValidIsoDateString(candidate.expiresAt) && Date.parse(candidate.expiresAt) > Date.now());
    return (typeof candidate.title === 'string' &&
        candidate.title.trim().length > 0 &&
        candidate.title.trim().length <= 100 &&
        (candidate.description === undefined ||
            candidate.description === null ||
            (typeof candidate.description === 'string' && candidate.description.trim().length <= 500)) &&
        typeof candidate.amountMinor === 'string' &&
        /^[1-9][0-9]*$/.test(candidate.amountMinor) &&
        isSupportedCurrency(candidate.currency) &&
        hasValidExpiresAt);
}
export function isUpdatePaymentLinkDraftInput(value) {
    if (typeof value !== 'object' || value === null || Array.isArray(value))
        return false;
    const candidate = value;
    const hasValidExpiresAt = candidate.expiresAt === undefined ||
        candidate.expiresAt === null ||
        (isValidIsoDateString(candidate.expiresAt) && Date.parse(candidate.expiresAt) > Date.now());
    return (typeof candidate.slug === 'string' &&
        candidate.slug.trim().length > 0 &&
        typeof candidate.title === 'string' &&
        candidate.title.trim().length > 0 &&
        candidate.title.trim().length <= 100 &&
        (candidate.description === undefined ||
            candidate.description === null ||
            (typeof candidate.description === 'string' && candidate.description.trim().length <= 500)) &&
        typeof candidate.amountMinor === 'string' &&
        /^[1-9][0-9]*$/.test(candidate.amountMinor) &&
        isSupportedCurrency(candidate.currency) &&
        hasValidExpiresAt);
}
export function isDeletePaymentLinkDraftInput(value) {
    if (typeof value !== 'object' || value === null || Array.isArray(value))
        return false;
    const candidate = value;
    return typeof candidate.slug === 'string' && /^pay-[0-9a-f]{12}$/.test(candidate.slug.trim());
}
export function isSetPaymentLinkVisibilityInput(value) {
    if (typeof value !== 'object' || value === null || Array.isArray(value))
        return false;
    const candidate = value;
    return (typeof candidate.slug === 'string' &&
        /^pay-[0-9a-f]{12}$/.test(candidate.slug.trim()) &&
        isPaymentLinkVisibility(candidate.visibility));
}
export function isDeactivatePaymentLinkInput(value) {
    if (typeof value !== 'object' || value === null || Array.isArray(value))
        return false;
    const candidate = value;
    return typeof candidate.slug === 'string' && candidate.slug.trim().length > 0;
}
export function isPublicPaymentLink(value) {
    if (typeof value !== 'object' || value === null || Array.isArray(value))
        return false;
    const candidate = value;
    if (typeof candidate.slug !== 'string' ||
        candidate.slug.length === 0 ||
        typeof candidate.title !== 'string' ||
        candidate.title.length === 0 ||
        !isNullableString(candidate.description) ||
        !isPaymentLinkStatus(candidate.status) ||
        candidate.visibility !== 'public' ||
        (candidate.expiresAt !== undefined &&
            candidate.expiresAt !== null &&
            !isValidIsoDateString(candidate.expiresAt)) ||
        candidate.paymentCollectionAvailable !== false) {
        return false;
    }
    return isOk(deserializeMoney(candidate.amount));
}
